import styled, { css } from 'styled-components';

export const ContainerStyled = styled.div<{ withEllipsis: boolean }>`
  ${({ withEllipsis }) => {
    return (
      withEllipsis &&
      css`
        overflow: hidden;

        > div {
          /* Override tooltip container */
          overflow: hidden;
        }
      `
    );
  }}
`;

export const IssueStyled = styled.div<{ alignCenter: boolean }>`
  display: flex;

  ${({ alignCenter }) => {
    return alignCenter ? 'align-items: center;' : '';
  }}
`;

export const IssueIconStyled = styled.div<{ height: string }>`
  width: 24px;
  min-width: 24px;
  display: flex;
  justify-content: center;
  padding: 8px 0 6px;

  > img {
    display: block;
    width: auto;
    border-radius: 3px;

    ${({ height }) => {
      switch (height) {
        case 'small':
          return 'height: 16px;';
        case 'medium':
          return 'height: 24px;';
        default:
          return 'height: 16px;';
      }
    }};
  }
`;

export const TestTypeIconStyled = styled.div`
  padding-right: 8px;
`;

export const IssueLinkStyled = styled.a`
  display: inline;
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  cursor: pointer;

  &:hover {
    color: var(--ds-text, var(--ds-fb-text));
  }
`;

export const IssueContentWrapperStyled = styled.div<{
  noPadding: boolean;
  withEllipsis: boolean;
}>`
  display: inline-block;
  text-align: left;
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));

  ${({ noPadding }) => {
    return noPadding ? '' : 'padding: 6px 0 6px 4px;';
  }}

  ${({ withEllipsis }) => {
    return (
      withEllipsis &&
      css`
        overflow: hidden;
        text-overflow: ellipsis;
      `
    );
  }}
`;

export const IssueSpanKeyStyled = styled.span<{ strikethrough: string }>`
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  font-weight: 500;
  margin-right: 4px;
  white-space: nowrap;

  ${({ strikethrough }) => {
    return `text-decoration: ${strikethrough}`;
  }}
`;

export const IssueSpanDescriptionStyled = styled.span`
  font-size: 14px;
  text-align: left;
  word-break: break-word;
  margin-right: 4px;
`;
